<template>
    <div id="container">
        <Spinner :show="loading"></Spinner>
        <Header></Header>
        <Modal v-if="modal.title" :title="modal.title" :body="modal.body" :centerBody="modal.centerBody" :className="modal.className" :buttons="modal.buttons"></Modal>
        <AccountTabs></AccountTabs>
        <section ref="content" id="content" class="section subnav no-vpadding">
            <Notification v-if="notification.show" :text="notification.text" :className="notification.className"></Notification>
            <div class="columns is-mobile is-centered">
                <div class="column is-one-fifth has-text-centered">
                    <a @click="save()" class="button is-primary is-fullwidth">
                        <span class="icon">
                            <i class="fa" :class="[loading ? 'fa-spinner fa-spin' : 'fa-save']"></i>
                        </span>
                    </a>
                </div>
            </div>
            <div class="columns is-mobile is-centered">
                <div class="column has-text-centered">
                    {{ $t("Age") }}
                </div>
                <div class="column has-text-centered">
                    {{ $t("Males") }}
                </div>
                <div class="column has-text-centered">
                    {{ $t("Females") }}
                </div>
            </div>
            <div class="columns is-mobile is-centered">
                <div class="column has-text-centered" style="padding-top: 20px">
                    0-11
                </div>
                <div class="column has-text-centered">
                    <div class="field">
                        <div class="control has-icons-left">
                            <input v-model.number="household.stats.m1" @click="hideTabs();if(household.stats.m1 == 0){household.stats.m1 = null}" @focus="hideTabs();if(household.stats.m1 == 0){household.stats.m1 = null}" @blur="showTabs()" class="input" autocomplete="off" type="number" min="0">
                            <span class="icon is-small is-left">
                                <i class="fa fa-user"></i>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="column has-text-centered">
                    <div class="field">
                        <div class="control has-icons-left">
                            <input v-model.number="household.stats.f1" @click="hideTabs();if(household.stats.f1 == 0){household.stats.f1 = null}" @focus="hideTabs();if(household.stats.f1 == 0){household.stats.f1 = null}" @blur="showTabs()" class="input" autocomplete="off" type="number" min="0">
                            <span class="icon is-small is-left">
                                <i class="fa fa-user"></i>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="columns is-mobile is-centered">
                <div class="column has-text-centered" style="padding-top: 20px">
                    11-18
                </div>
                <div class="column has-text-centered">
                    <div class="field">
                        <div class="control has-icons-left">
                            <input v-model.number="household.stats.m2" @click="hideTabs();if(household.stats.m2 == 0){household.stats.m2 = null}" @focus="hideTabs(); if(household.stats.m2 == 0){household.stats.m2 = null}" @blur="showTabs()" class="input" autocomplete="off" type="number" min="0">
                            <span class="icon is-small is-left">
                                <i class="fa fa-user"></i>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="column has-text-centered">
                    <div class="field">
                        <div class="control has-icons-left">
                            <input v-model.number="household.stats.f2" @click="hideTabs();if(household.stats.f2 == 0){household.stats.f2 = null}" @focus="hideTabs(); if(household.stats.f2 == 0){household.stats.f2 = null}" @blur="showTabs()" class="input" autocomplete="off" type="number" min="0">
                            <span class="icon is-small is-left">
                                <i class="fa fa-user"></i>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="columns is-mobile is-centered">
                <div class="column has-text-centered" style="padding-top: 20px">
                    18-65
                </div>
                <div class="column has-text-centered">
                    <div class="field">
                        <div class="control has-icons-left">
                            <input v-model.number="household.stats.m3" @click="hideTabs(); if(household.stats.m3 == 0){household.stats.m3 = null}" @focus="hideTabs(); if(household.stats.m3 == 0){household.stats.m3 = null}" @blur="showTabs()" class="input" autocomplete="off" type="number" min="0">
                            <span class="icon is-small is-left">
                                <i class="fa fa-user"></i>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="column has-text-centered">
                    <div class="field">
                        <div class="control has-icons-left">
                            <input v-model.number="household.stats.f3" @click="hideTabs(); if(household.stats.f3 == 0){household.stats.f3 = null}" @focus="hideTabs(); if(household.stats.f3 == 0){household.stats.f3 = null}" @blur="showTabs()" class="input" autocomplete="off" type="number" min="0">
                            <span class="icon is-small is-left">
                                <i class="fa fa-user"></i>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="columns is-mobile is-centered">
                <div class="column has-text-centered" style="padding-top: 20px">
                    65+
                </div>
                <div class="column has-text-centered">
                    <div class="field">
                        <div class="control has-icons-left">
                            <input v-model.number="household.stats.m4" @click="hideTabs(); if(household.stats.m4 == 0){household.stats.m4 = null}" @focus="hideTabs(); if(household.stats.m4 == 0){household.stats.m4 = null}" @blur="showTabs()" class="input" autocomplete="off" type="number" min="0">
                            <span class="icon is-small is-left">
                                <i class="fa fa-user"></i>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="column has-text-centered">
                    <div class="field">
                        <div class="control has-icons-left">
                            <input v-model.number="household.stats.f4" @click="hideTabs(); if(household.stats.f4 == 0){household.stats.f4 = null}" @focus="hideTabs(); if(household.stats.f4 == 0){household.stats.f4 = null}" @blur="showTabs()" class="input" autocomplete="off" type="number" min="0">
                            <span class="icon is-small is-left">
                                <i class="fa fa-user"></i>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <NavigationTabs></NavigationTabs>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header.vue";
import Modal from "@/components/Modal.vue";
import AccountTabs from "@/components/AccountTabs.vue";
import Notification from "@/components/Notification.vue";
import NavigationTabs from "@/components/NavigationTabs.vue";
import Spinner from "@/components/Spinner.vue";

export default {
  name: "AccountPeople",
  components: {
    Header,
    Modal,
    AccountTabs,
    Notification,
    NavigationTabs,
    Spinner
  },
  async mounted()
  {
    const response = await this.$http.get(`/Household`);

    if(!response.data.household.stats)
    {
        response.data.household.stats = this.household.stats;
    }

    this.household = response.data.household;
  },
  data () {
    return {
        household: {
            stats: {
            m1: 0,
            m2: 0,
            m3: 0,
            m4: 0,
            f1: 0,
            f2: 0,
            f3: 0,
            f4: 0
        }
        },
        modal: {
            title: null,
            body: null,
            centerBody: true,
            className: "",
            buttons:
            [
                {id: 0, title: this.$t("OK"), className: "is-primary", click: () => { this.modal.className = ""; }}
            ]
        }
    }
  },
  methods:
  {
    save: async function() {
        let numberInHousehold = 0;
        let body = {};

        for(const key in this.household.stats)
        {
            if(this.household.stats[key] == null)
            {
                this.household.stats[key] = 0;
            }

            numberInHousehold += this.household.stats[key];
        }

        if(numberInHousehold == 0)
        {
            alert(this.$t("EnterNumberInHousehold"));
            return;
        }

        body =
        {
            numberOfPeople: numberInHousehold,
            stats: this.household.stats
        }

        this.$refs.content.scrollTo(0, 0);

        try
        {
            const response = await this.$http.post(`/Household`, body);
            this.notification =
            {
                show: true,
                className: "is-success",
                text: this.$t("Updated")
            }
        }

        catch(error)
        {
            if(error.response)
            {
                this.notification =
                {
                    show: true,
                    className: "is-danger",
                    text: error.response.data.message
                }
            }
            
            else
            {
                this.notification =
                {
                    show: true,
                    className: "is-danger",
                    text: this.$t("Error")
                }
            }
        }
    }
  }
};
</script>
